import { Directive, Input, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[qtHeaderDef]',
  standalone: false,
})
export class HeaderDefDirective {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);

  @Input('qtHeaderDef') id: string;

  template = this.templateRef;
}
